<template>
  <div class="row">
    
    <aside class="col-md-3 col-sm-12 cus-sidebar">
      <ResourceSidebar />
    </aside>
    <div v-if="isLoading" class="loader">
      <div class="wave-container">
        <div class="wave"></div>
        <div class="wave"></div>
        <div class="wave"></div>
        <div class="wave"></div>
        <div class="wave"></div>
      </div>
      <p>Loading...</p>
    </div>
    <div v-if="!isLoading" id="content" class="col-md-9 col-sm-12">
      <div class="material-box bg-white">
        <div class="row content-row">
          <div class="col-md-12 top-title">
            <h3>Members Directory</h3>
          </div>
          <div class="col-md-12">
            <div class="p-b-10">
              <div class="row">
                <!-- begin col-6 -->
                <div class="col-md-12 box-detail m-b-10"> The following doctors have elected to list themselves. Please
                  feel free to reach out to them to collaborate and discuss chiropractic. </div>
                  <div class="col-lg-12">
                    <div class="table-responsive">
                      <div id="table_id_wrapper" class="dataTables_wrapper no-footer">
                        <table class="table member-table table-td-valign-middle table-td-valign-main weekly " id="table_id">
                          <thead>
                            <tr role="row">
                              <th style="width: 118.4px;" @click="sortTable('FirstName')">First Name
                                <i v-if="sortKey === 'FirstName'" class="ti-arrow-down fa-sm"></i>
                                <i v-if="sortKey !== 'FirstName'" class="ti-arrow-up fa-sm"></i>
                              </th>
                              <th style="width: 116.4px;" @click="sortTable('LastName')">Last Name
                                <i v-if="sortKey === 'LastName'" class="ti-arrow-down fa-sm"></i>
                                <i v-if="sortKey !== 'LastName'" class="ti-arrow-up fa-sm"></i>
                              </th>
                              <th style="width: 127.4px;" @click="sortTable('City')">City
                                <i v-if="sortKey === 'City'" class="ti-arrow-down fa-sm"></i>
                                <i v-if="sortKey !== 'City'" class="ti-arrow-up fa-sm"></i>
                              </th>
                              <th style="width: 69.4px;" @click="sortTable('Code')">State
                                <i v-if="sortKey === 'Code'" class="ti-arrow-down fa-sm"></i>
                                <i v-if="sortKey !== 'Code'" class="ti-arrow-up fa-sm"></i>
                              </th>
                              <th style="width: 131.4px;">Phone</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr class="odd" v-for="(data, index) in sortedData" :key="index">
                              <td>{{ data.FirstName }}</td>
                              <td>{{ data.LastName }}</td>
                              <td>{{ data.City }}</td>
                              <td>{{ data.Code }}</td>
                              <td> {{ formatPhoneNumber(data.Phone1) }}</td>
                            </tr>
                            
                          </tbody>
                        </table>
                        
                      </div>
                    </div>
                  </div>
                  
                  <!-- end row -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end page-header -->
      </div>
      
    </div>
  </template>
  
  <script>
  import userAPI from '../userApi';
  
  // import ModuleBox from './components/ModuleBox.vue';
  import ResourceSidebar from './components/ResourceSidebar.vue';
  export default {
    components: { ResourceSidebar },
    name: "MemberDictionary",
    data() {
      return {
        tableData: [],
        sortKey: 'LastName'
      }
    },
    methods: {
      sortTable(key) {
        this.sortKey = key;
      },
      formatPhoneNumber(phone) {
        const cleaned = ('' + phone).replace(/\D/g, ''); // Remove non-numeric characters
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

        if (match) {
          return `(${match[1]}) ${match[2]}-${match[3]}`;
        }

        return phone;
      },
      getUsersForResources() {
        this.isLoading = true;
        
        userAPI.getUsersForResources(res => {
          this.tableData = res.data.data;
          this.isLoading = false;
          console.log(this.tableData);
        }, err => {
          console.log(err);
          this.isLoading = false;
          
        })
      }
    },
    mounted() {
      this.getUsersForResources()
    },
    watch: {
      sortKey() {
        this.tableData = this.sortedData;
      },
    },
    computed: {
      sortedData() {
        return this.tableData.slice().sort((a, b) => {
          // Compare the values based on the current sort key
          if (a[this.sortKey] < b[this.sortKey]) return -1;
          if (a[this.sortKey] > b[this.sortKey]) return 1;
          return 0;
        });
      },
    },
  }
</script>
